import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import ContentDetailView from "composer/views/content/ContentDetailView.jsx"

import { Stepper, Step, StepLabel, Grid, Dialog, DialogContent, DialogActions, Icon, Button, Typography, Box } from '@material-ui/core';

const STEP_CONTENT_TYPE = 0;
const STEP_EDIT_CONTENT = 1;

class CreateContentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      activeStep: STEP_CONTENT_TYPE,
      contentTypeArray: [],
      currentContentType: -1,
    };
    autoBind(this);

    for (var i = 0; i < this.props.parent.getContentTypeCount(); i++) {
      this.state.contentTypeArray.push(null);
    }
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleContentTypeClicked(index) {
    this.setState({ currentContentType: index });
    this.state.currentContentType = index;
    this.changeActiveStep(STEP_EDIT_CONTENT);
  }

  handleBackClicked() {
    this.changeActiveStep(STEP_CONTENT_TYPE);
  }

  handleFinishClicked() {
    // todo: check empty content
    let maxDisplayIndex = -1;
    for (let i = 0; i < this.props.parent.state.contentList.length; i++) {
      let displayIndex = parseInt(this.props.parent.state.contentList[i].display_index);
      if (displayIndex > maxDisplayIndex) {
        maxDisplayIndex = displayIndex;
      }
    }
    maxDisplayIndex++;

    let contentDetailViewState = this.refs.contentDetailView.state;
    let contentDetailView = this.refs.contentDetailView;
    let return_message = contentDetailView.checkEmptyContent();
    // console.log('return message:', return_message);
    // console.log('content:', contentDetailViewState.contentText);
    // console.log('payload:', contentDetailViewState.contentPayload);
    // if (contentDetailViewState.contentText == "" && Object.keys(contentDetailViewState.contentPayload).length == 0){

    switch(return_message.flag){
      case ContentDetailView.TAG_OK:
        // save tag normally
        let requestObj = {
          table: "component",
          row: {
            name: contentDetailViewState.contentName,
            kind: this.state.currentContentType,
            display_index: maxDisplayIndex,
            rationale: contentDetailViewState.contentCategory,
            diff: contentDetailViewState.contentDifficulty,
            epack_id: this.props.root.getCurrentLocale().id,
            hotspot_id: this.props.parent.props.currentHotspot.id,
            content: contentDetailViewState.contentText,
            payload: JSON.stringify(contentDetailViewState.contentPayload),
          }
        }
        this.props.root.refs.API.request("insert", requestObj, this.createContentOK, this.createContentFail);
        this.handleClose();
        break;

      case ContentDetailView.TAG_WARNING:
        // prompt user
        let dialogText = {
          title: Localization.strings.EXIT,
          content: return_message.message,
          confirm: Localization.strings.YES,
        };
        this.props.root.refs.confirmDialog.show(dialogText, ()=>{
          let requestObj = {
            table: "component",
            row: {
              name: contentDetailViewState.contentName,
              kind: this.state.currentContentType,
              display_index: maxDisplayIndex,
              rationale: contentDetailViewState.contentCategory,
              diff: contentDetailViewState.contentDifficulty,
              epack_id: this.props.root.getCurrentLocale().id,
              hotspot_id: this.props.parent.props.currentHotspot.id,
              content: contentDetailViewState.contentText,
              payload: JSON.stringify(contentDetailViewState.contentPayload),
            }
          }
          this.props.root.refs.API.request("insert", requestObj, this.createContentOK, this.createContentFail);
          this.handleClose();
        }, ()=>{});
        break;

      case ContentDetailView.TAG_ERROR:
        // block user from saving this problematic tag
        this.props.root.addNotification(return_message.message, false);
        break;
    }
  }

  createContentOK(res) {
    this.props.parent.refreshContentList();

    var requestObj = {epack_id: this.props.root.getCurrentLocale().id};
    this.props.root.refs.API.request("touch_epack", requestObj);
  }

  createContentFail(err) {
    console.log("create content fail " + err);
  }

  changeActiveStep(i) {
    this.setState({activeStep: i});
    this.state.activeStep = i;
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'lg'}
          onClose={this.handleClose}
        >
          <DialogContent>
            <Stepper activeStep={this.state.activeStep}>
              <Step key={"CONTENT_TYPE"}>
                <StepLabel>{Localization.strings.CONTENT_TYPE}</StepLabel>
              </Step>
              <Step key={"EDIT_CONTENT"}>
                <StepLabel>{Localization.strings.EDIT_CONTENT}</StepLabel>
              </Step>
            </Stepper>

            <Switch condition={this.state.activeStep}>
              <Case value={STEP_CONTENT_TYPE}>
                <Grid container spacing={2}>
                  {this.state.contentTypeArray.map( (row, i) => {
                    return (
                      <Grid key={i} item xs={6} sm={3}>
                        <Button
                          size="large"
                          onClick={()=>this.handleContentTypeClicked(i+1)}
                        >
                          <Icon style={{fontSize: '48px', color:"#9e9e9e"}}>
                            {Config.GET_HOTSPOT_CONTENT_CONFIG(i+1).icon}
                          </Icon>
                          <div style={{textAlign:'left', padding:'0 0 0 14px'}}>
                            <Typography color='primary'>
                              <Box fontWeight="fontWeightBold">
                                {Config.GET_HOTSPOT_CONTENT_CONFIG(i+1).title}
                              </Box>
                            </Typography>
                            <Typography variant="body2" style={{textTransform:'none', color:"#707070"}}>
                              {Config.GET_HOTSPOT_CONTENT_CONFIG(i+1).description}
                            </Typography>
                          </div>
                        </Button>
                      </Grid>
                    );
                  })}
                </Grid>
              </Case>
              <Case value={STEP_EDIT_CONTENT}>
                <ContentDetailView root={this.props.root} parent={this} ref="contentDetailView" contentType={this.state.currentContentType}/>
              </Case>
            </Switch>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Switch condition={this.state.activeStep}>
              <Case value={STEP_CONTENT_TYPE}>
                <Button onClick={this.handleClose}>{Localization.strings.CANCEL}</Button>
              </Case>
              <Case value={STEP_EDIT_CONTENT}>
                <Button onClick={this.handleBackClicked}>{Localization.strings.BACK}</Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleFinishClicked}
                >
                  {Localization.strings.FINISH}
                </Button>
              </Case>
            </Switch>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default CreateContentDialog;
